import { css } from '@emotion/react';
import { CssVars, Modal, NeutralColorToken, SemanticColorToken, Type } from '@robinhood/design';
import { RowUtils } from '@robinhood/design/product/components/Rows/RowUtils';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  onDismiss: () => void;
}

const IncomeModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <div>
        <div css={disclaimerSection}>
          <Type.Text size='M' isBold>
            Include all housing payments such as:
          </Type.Text>
          <div css={row}>
            <RowUtils.Icon type='BubbleChecked24' color={SemanticColorToken.Positive} />
            <Type.Text size='M'>Rent</Type.Text>
          </div>
          <div css={row}>
            <RowUtils.Icon type='BubbleChecked24' color={SemanticColorToken.Positive} />
            <Type.Text size='M'>Mortgage</Type.Text>
          </div>
        </div>
        <div css={subtitle}>
          <Type.Text size='S' color={NeutralColorToken.Fg2}>
            Input “0” if you don’t have a housing payment.
          </Type.Text>
        </div>
        <div css={buttonContainer}>
          <Button label='Dismiss' width='full' type='button' onClick={onDismiss} />
        </div>
      </div>
    </Modal>
  );
};

const root = css`
  padding: 0px;
`;

const subtitle = css`
  padding: 16px 24px;
  text-align: center;
`;

const disclaimerSection = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

const row = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const buttonContainer = css`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 40px;
`;

export default IncomeModal;
